import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Reveal from '../components/ui/Reveal';
import API, { UPLOADS_URL } from '../api/axios';

const ExtraCurriculumActivitiesPage = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    API.get('/pages/public/extra-curriculum-activities').then(res => {
      if (res.data?.data) setPageData(res.data.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const title = 'Extracurricular Activities';

  const fallbackHtml = `<p>At Cambridge International Sr. Sec. School, Bhadana we strive to offer an educational process that promotes togetherness and creates a stress-free learning experience. Our extra-curricular activities are focused on motivating the students to compete and push beyond their boundaries. We value individuality and know that every student has different talents and demands special attention.</p>
<ul>
<li><strong>Clubs and Societies</strong></li>
</ul>
<p>Students can join various clubs and societies that cater to their interests, including debate club, science club, literary society, and more. These platforms help students develop leadership skills and explore their passions.</p>
<ul>
<li><strong>Sports and Athletics</strong></li>
</ul>
<p>Sports is one of the best ways to develop skills like confidence, collaboration, courage, and discipline. Cambridge International Sr. Sec. School offers both outdoor and indoor sports facilities. Through regular sports training and physical education, we help in building the student's muscle strength and gross motor skills.</p>
<ul>
<li><strong>Performing Arts</strong></li>
</ul>
<p>We encourage students to explore their creative side through dance, music, and drama. Our dedicated performing arts program helps students build confidence and express themselves creatively.</p>
<ul>
<li><strong>Community Service</strong></li>
</ul>
<p>We instill a sense of social responsibility in our students through various community service initiatives. Students learn the value of giving back to society and develop empathy and compassion.</p>
<ul>
<li><strong>Workshops and Events</strong></li>
</ul>
<p>Regular workshops, seminars, and events are organized to expose students to new ideas and experiences. These events complement the academic curriculum and provide holistic learning opportunities.</p>`;

  if (loading) return <div className="loading-screen"><i className="fas fa-spinner fa-spin"></i></div>;

  return (
    <>
      <SEO title={title} description="Extracurricular Activities at Cambridge International Sr. Sec. School, Bhadana." keywords="Extracurricular Activities, Cambridge International Sr. Sec. School" />

      <section className="page-hero">
        <img src={pageData?.banner_image ? `${UPLOADS_URL}/${pageData.banner_image}` : '${process.env.PUBLIC_URL}/images/page-banners/extra-curricullam.jpg'} alt={title} className="page-hero-img" loading="eager" />
        <div className="page-hero-content">
          <div className="container">
            <div className="page-hero-inner">

            </div>
          </div>
        </div>
      </section>

      <section className="content-page">
        <div className="container">
          <div className="max-w-[1200px] mx-auto">
            <div className="card p-7 md:p-10">
              <div className="text-body leading-relaxed" dangerouslySetInnerHTML={{ __html: pageData?.content || fallbackHtml }} />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ExtraCurriculumActivitiesPage;

